import { render, staticRenderFns } from "./courseZlpf.vue?vue&type=template&id=072f31a5&scoped=true&"
import script from "./courseZlpf.vue?vue&type=script&lang=js&"
export * from "./courseZlpf.vue?vue&type=script&lang=js&"
import style0 from "./courseZlpf.vue?vue&type=style&index=0&id=072f31a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072f31a5",
  null
  
)

export default component.exports